package com.dotdrives.web.pages.updates
import com.dotdrives.model.*
import kotlinx.datetime.LocalDate

data class ReportUrlState(val year:Int,val period:String="fiscal",val start:String?=null,val end:String?=null,val target:String?=null,val steward:String?=null)

fun reportUrl(s:ReportUrlState):String {
 fun enc(v:String)=js("encodeURIComponent(v)") as String
 val pairs=mutableListOf("year=${s.year}","period=${enc(s.period)}")
 s.start?.let { pairs += "start=${enc(it)}" }; s.end?.let { pairs += "end=${enc(it)}" }
 s.target?.let { pairs += "target=${enc(it)}" }; s.steward?.let { pairs += "steward=${enc(it)}" }
 return "#/reports?"+pairs.joinToString("&")
}

fun currentReportFiscalYear(today:LocalDate,month:Int,day:Int):Int =
 if(today > fiscalYearPeriod(today.year,month,day).endInclusive) today.year+1 else today.year

fun parseReportUrl(hash:String,defaultYear:Int=kotlin.js.Date().getUTCFullYear()):ReportUrlState {
 fun dec(v:String)=js("decodeURIComponent(v)") as String
 val values=hash.substringAfter('?',"").split('&').mapNotNull { val p=it.split('=',limit=2); if(p.size==2) p[0] to dec(p[1]) else null }.toMap()
 return ReportUrlState(values["year"]?.toIntOrNull()?:defaultYear,values["period"]?:"fiscal",values["start"],values["end"],values["target"],values["steward"])
}

fun resolveReportPeriod(state:ReportUrlState,today:LocalDate,fiscalMonth:Int,fiscalDay:Int):ReportPeriod = when(state.period.lowercase()) {
 "rollingtwelve","rolling" -> rollingTwelveMonths(today)
 "custom" -> runCatching { customReportPeriod(LocalDate.parse(state.start!!),LocalDate.parse(state.end!!)) }.getOrElse { fiscalYearPeriod(state.year,fiscalMonth,fiscalDay) }
 else -> fiscalYearPeriod(state.year,fiscalMonth,fiscalDay)
}

fun reportsResponsiveCss()="""
 .reports-monthly-scroll { overflow-x: auto; }
 .reports-chart-data { width: 100%; }
 @media(max-width:700px){.reports-filters{width:100%;overflow-x:auto}.reports-monthly-table{min-width:680px}}
""".trimIndent()

data class ReportChartLines(val actual:String,val prior:String,val goal:String)
fun reportChartLines(actual:List<Double>,prior:List<Double>,goal:List<Double>):ReportChartLines {
 val values=actual+prior+goal+0.0; val min=values.minOrNull()?:0.0;val max=values.maxOrNull()?:1.0;val span=(max-min).takeIf{it>0}?:1.0
 fun points(series:List<Double>)=series.mapIndexed { i,v -> "${if(series.size<2) 0 else i*800/(series.size-1)},${10+((max-v)/span*200).toInt()}" }.joinToString(" ")
 return ReportChartLines(points(actual),points(prior),points(goal))
}

data class ReportsContentState(val showEmptyNotice:Boolean,val showReportBody:Boolean)
fun reportsContentState(summary:GivingSummary)=ReportsContentState(summary.giftCount==0&&summary.orgBudget.raisedAmount==0.0,true)
